import { useContext, useState } from "react";

import Button from "antd/lib/button";
import MailOutlined  from "@ant-design/icons/MailOutlined";
import { ModalContext } from "../../../../contexts/modal/index.context";
import Popconfirm from "antd/lib/popconfirm";
import { PopconfirmProps } from "./types";
import { SessionContext } from "../../../../contexts/session/index.context";
import { TranslationContext } from "../../../../contexts/translation/index.context";
import message from "antd/lib/message";
import { request } from "../../../../services";
import styles from "./styles.module.scss";
import { useLocation } from "react-router-dom";
import checkBefore from "../../../../helpers/selectionOfActions";

//UI



//Icons


export default function PopconfirmComponent(props: PopconfirmProps) {
  const [loading, setLoading] = useState(false);
  const { intl } = useContext(TranslationContext);
  const { sessionData } = useContext(SessionContext);
  const location = useLocation();
console.log("Props_NAME ", props)
  const info = (success: boolean) => {
    success? message.success(props.isCombined? intl("email-is-generate"):intl("email-bulk-is-generate"))
      : message.error(props.isCombined? intl("email-is-not-generate"):intl("email-bulk-is-not-generate"));
  };
  const handleOk = async () => {
    let accessRights = await checkBefore(location.pathname, undefined, 'create-letter');
    if(!accessRights) {
        message.error(intl("you-do-not-have-access-rights"));
      return;
    }
    setLoading(true);
    const success = (
      await request(
        `${location.pathname}/addelectronicmailentry`,
        {
          method: "post",
          body: {
            bta_documents_id: sessionData?.bta_documents_id,
            type_email: props.isCombined ? 0 : 1,
          },
          cancelTokenKey: "addelectronicmailentry",
        }
      )
    )?.success;
    info(success);
    setLoading(false);
  };
  return (
    <Popconfirm
      title={props.isCombined? intl("question-generate-email"): intl("question-generate-bulk-email")}
      onConfirm={handleOk}
      okButtonProps={{ loading, className: styles["popconfirm"] }}
      okText={intl("ok")}
      cancelText={intl("cancel")}
    >
      <Button
        className={styles["button"]}
        disabled={props.disabled}
        icon={<MailOutlined />}
      >
        {intl(props.name || "email")}
      </Button>
    </Popconfirm>
  );
}
